import { inject, Injectable } from '@angular/core';
import { FundraiserMinimal } from '@fmnts/api';
import {
  TemplateEvaluationError,
  TemplateExpression,
  TemplateInterpolator,
} from '@fmnts/declarative-forms';
import { LegacyStore } from '@formunauts/next/data-access';
import { map, Observable, throwError } from 'rxjs';

/**
 * Template interpolator for fundraiser related expressions.
 *
 * Supports:
 *  - `fundraiser:code`
 *  - `fundraiser:fistname`
 *  - `fundraiser:lastname`
 */
@Injectable()
export class FundraiserTemplateService implements TemplateInterpolator {
  private readonly store = inject(LegacyStore);

  canCreate(expression: TemplateExpression): boolean {
    return expression.expression.startsWith('fundraiser:');
  }

  expression$(expression: TemplateExpression): Observable<string> {
    return this.fundraiser$(expression);
  }

  private fundraiser$(exp: TemplateExpression): Observable<string> {
    const { expression } = exp;
    const fundraiser$ = this.store.select<FundraiserMinimal>(
      'next.fundraisers.self',
    );

    switch (expression) {
      case 'fundraiser:firstname':
        return fundraiser$.pipe(map((f) => f.firstName));
      case 'fundraiser:lastname':
        return fundraiser$.pipe(map((f) => f.lastName));
      case 'fundraiser:code':
        return fundraiser$.pipe(map((f) => f.fundraiserCode));
    }

    return throwError(
      () =>
        new TemplateEvaluationError(
          exp,
          `Unknown fundraiser expression ${expression}`,
        ),
    );
  }
}
